module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-breadcrumbs', {
    attrs: {
      "icons": "",
      "divider": "chevron_right"
    }
  }, _vm._l((_vm.breadcrumbs), function(item) {
    return _c('v-breadcrumbs-item', {
      key: item.text,
      attrs: {
        "disabled": item.disabled,
        "router": "",
        "href": _vm.getHref(item)
      }
    }, [_vm._v("\n    " + _vm._s(item.text) + "\n  ")])
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/prod-isrs-frontend-mb_master/~/vue-loader/lib/template-compiler?{"id":"data-v-34ed20d2"}!/export/jenkins/workspace/prod-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=template&index=0!./client/components/IsrsBreadcrumb.vue
// module id = 930
// module chunks = 1